import { createFileRoute } from "@tanstack/react-router";
import { ValuationEntries } from "@/components/ValuationEntries";

export const Route = createFileRoute("/_authenticated/valuation-entries/")({
  component: ValuationEntries,
  staticData: { page: "valuations" },
});
